import React from "react";
import "./services.css"
import { FaArrowDown } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

function Services() {

  const scrollToSection = () => {
    const section = document.getElementById("service-list");
    if (section) {
      const offset = 80; // Adjust this value for extra spacing
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionPosition - offset,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="services-page">
      <img src={require("../images/services-banner.png")} alt="" className="services-page-banner"/>

      <div className="services-header">
        <h1>บริการของเรา</h1>
        <p>งานห้องครัวทุกประเภท ครบวงจร ตั้งแต่ ผลิต ติดตั้ง ให้คำปรึกษา มีสินค้าครบทุกประเภท สามารถผลิตหรือนำเข้าจากต่างประเทศ ขึ้นงานสแตนเลส และเหล็ก ได้อย่างแม่นยำและตรงตามสเปค</p>
        <p className="service-scroll-down" onClick={scrollToSection} style={{cursor: 'pointer'}}><FaArrowDown style={{marginRight:'4px',height : '12px', width: '12px'}} />เลื่อนลงเพื่อดูเพิ่มเติม</p>
      </div>

      <div className="service-list" id="service-list">
        <div>
          <Link to="/service1"><h3>01 ติดตั้งระบบดูดอากาศในห้องครัว</h3></Link>
          <Link to="/service2"><h3>02 ติดตั้งระบบแก๊สและระบบความปลอดภัย</h3></Link>
          <Link to="/service3"><h3>03 ผลิตและนำเข้าเครื่องครัวครบวงจร</h3></Link>
          <Link to="/service4"><h3 style={{borderBottom: '2px solid #D9D9D9'}}>04 งานผลิตสแตนเลสและเหล็กตามแบบ</h3></Link>
        </div>
      </div>
      
      <div className="services-page-des">
        <img src={require("../images/services-page-image.png")} alt="" className="services-page-image" />
        
        <div>
          <h1>
            คุณภาพเหนือระดับ <br />
            บริการเหนือความคาดหมาย
          </h1>
          <p>
            Power Bunch เป็นบริษัทที่ดำเนินธุรกิจ
            มายาวนานกว่า 30 ปี เราให้ความสำคัญกับ
            ความซื่อสัตย์และความจริงใจในการค้าขาย พร้อมให้บริการลูกค้าด้วยมาตรฐานที่ชัดเจน
            และโปร่งใส มีหน้าร้านจริง สามารถเข้าชม
            สินค้าได้ทุกวัน เรามุ่งมั่นให้บริการที่ดีที่สุด
            เพื่อให้ลูกค้ามั่นใจในคุณภาพของสินค้า
          </p>
          <Link to="/about" className="services-about-link">
            อ่านเรื่องราวของเราเพิ่มเติม
            <FaArrowRight/>
          </Link>
        </div>
        
      </div>
      
    </div>
  );
}

export default Services;
